module.exports = __webpack_public_path__ + "2e4ac2b387e7f1827ca5d312445dab21.pdf";